const LiveGraphicsSection: React.FC = () => {
  return (
    <>
      <p>Live Graphics coming soon..</p>
    </>
  );
};
export default LiveGraphicsSection;
